import { Box, Text, VStack } from '@chakra-ui/react'
import { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { useDropzoneStyles } from '~/components/shared/componentStyles/Dropzone.style'
import { Spacing } from '~/types/ThemeTypes'

import { CoverPage } from './ContentAcceptedMulti'
import { Context } from './Context'

export default function ContentDefault() {
  const { t } = useTranslation()
  const {
    coverPage,
    currentVariant,
    props: {
      allowMultiple,
      placeholder = t('contentDefault.placeholder'),
      maxFileSizePlaceholder = '',
    },
  } = useContext(Context)

  const styles = useDropzoneStyles({
    variant: currentVariant,
  })

  const placeholderJsx = (
    <VStack alignSelf="center" gap={0}>
      <Text css={styles.text}>{placeholder}</Text>
      {maxFileSizePlaceholder ? (
        <Text css={styles.text}>{maxFileSizePlaceholder}</Text>
      ) : null}
    </VStack>
  )

  if (!allowMultiple || !coverPage) {
    return placeholderJsx
  }

  return (
    <VStack width="100%" gap={2} paddingY={Spacing._3}>
      {/* Clicks here (including in the portalled preview dialog) must not
          bubble to the dropzone root, which would open the file browser. */}
      <Box asChild width="100%" onClick={(e) => e.stopPropagation()}>
        <ul style={{ paddingLeft: 0 }}>
          <CoverPage file={coverPage} />
        </ul>
      </Box>
      {placeholderJsx}
    </VStack>
  )
}
